import { createFileRoute } from "@tanstack/react-router";
import { CITY_PAGES } from "@/content/localPages";
import { localPageHead } from "@/content/localPageHead";
import { LocalPageView } from "@/components/marketing/LocalPageView";

export const Route = createFileRoute("/chandler-ppc-agency")({
  head: () => localPageHead(CITY_PAGES.chandler!),
  component: ChandlerPage,
});

function ChandlerPage() {
  return <LocalPageView page={CITY_PAGES.chandler!} />;
}
